const quotes = `
query quotes($skip: Int, $limit: Int, $sort: sortInput, $where: policyWhereInput){
  policies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list{
      id
      source
      createdAt
      issuerNumber
      holder{
        name
        contacts{ id type value }
      }
      acceptedOffer {
        product{
          name
          insurer { name }
          productId { type }
        }
        premium {
          appliedDiscounts { code }
          formattedPrice
        }
      }
      offers {
        id
        product {
            name
        }
      }
      product{
        name
        insurer { name }
        productId { type }
      }
      premium {
        appliedDiscounts { code }
        formattedPrice
      }
      status
      startDate
      endDate
      issueDate
      referrer{ name }
      rejectionCodes { code name }
      rejectionRemarks
    }
  }
}
`

const quote = `
fragment Value on scalarValue {
  booleanValue
  dateValue
  stringValue
  numberValue
}

fragment TreeMapValues on scalarValue {
  ...Value
  arrayValue {
    ...Value
    objectValue {
      key value { ...Value }
    }
  }
}

query quote($skip: Int, $limit: Int, $sort: sortInput, $where: policyWhereInput){
  policies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list{
      id
      source
      status
      client{ id name }
      createdAt
      createdBy{
        username
      }
      lastModifiedAt
      lastModifiedBy { username }
      referrer { name internalCode }
      values {
        key
        value {
          ...TreeMapValues
        }
      }
      acceptedOffer{
        id
        premium{
          amount
          currencyCode
          formattedPrice
          originalPrice
          formattedOriginalPrice
          appliedTaxes{
            code
            name
            ratio
            flat
            formattedFlat
            order
            formattedOriginalPrice
            originalPrice
          }
          appliedDiscounts{
            code
            ratio
            flat
            formattedFlat
            order
            formattedOriginalPrice
            originalPrice
          }
          loadings{
            id
            codeName{
              code
              name
            }
            ratio
            flat
          }
        }
        exclusions{
          id
          codeName{
            code
            name
          }
          remark
        }
        product{
          productId{
            plan
            type
            version
          }
          name
          insurer{ id name logoUrls{ typeA } }
          benefits(typeIds: [], includeOptionals: true) { typeId value }
        }
        benefitOptions{
          name
          formattedValue
          value {
            ...TreeMapValues
          }
        }
      }
      premium{
        amount
        currencyCode
        formattedPrice
        originalPrice
        formattedOriginalPrice
        appliedTaxes{
          code
          name
          ratio
          flat
          formattedFlat
          order
          formattedOriginalPrice
          originalPrice
        }
        appliedDiscounts{
          code
          ratio
          flat
          formattedFlat
          order
          formattedOriginalPrice
          originalPrice
        }
        loadings{
          id
          codeName{
            code
            name
          }
          ratio
          flat
        }
      }
      exclusions{
        id
        codeName{
          code
          name
        }
        remark
      }
      product{
        productId{
          plan
          type
          version
        }
        name
        insurer{ id name logoUrls{ typeA } }
        benefits(typeIds: [], includeOptionals: true) { typeId value }
      }
      benefitOptions{
        name
        formattedValue
        value {
          ...TreeMapValues
        }
      }
      attachments{ path fileName createdAt }
      notes{
        id
        title
        content
        createdAt
        createdBy{
          username
          associatedUser{
            name
          }
        }
      }
      holder{
        ...on individual{
          id
          __typename
          name
          englishFirstName
          englishLastName
          chineseFirstName
          chineseLastName
          dateOfBirth
          gender
          occupation
          maritalStatus
          employmentStatus
          salutation
          preferredCommunicationChannel
          preferredLanguage
          countryOfResidency
          contacts{ id type value }
          identities{ id type value }
          facts{id type
            value{
              stringValue
              dateValue
              booleanValue
              numberValue
              arrayValue {
                stringValue
              }
            }
          }
          addresses{fields id type}
          relationships {
            type
            entity {
              name
            }
            values {
              key
              value
            }
          }
        }
        ...on company{
          id
          __typename
          name
          registrationNumber
          natureOfBusiness
          contacts{ id type value }
          addresses{fields id type}
          facts{id type
            value{
              stringValue
              dateValue
              booleanValue
              numberValue
              arrayValue {
                stringValue
              }
            }
          }
        }
      }
      insured{
        ...on individual{
          id
          __typename
          name
          englishFirstName
          englishLastName
          chineseFirstName
          chineseLastName
          dateOfBirth
          gender
          occupation
          maritalStatus
          employmentStatus
          salutation
          preferredCommunicationChannel
          preferredLanguage
          countryOfResidency
          contacts{ id type value }
          identities{ id type value }
          facts{id type
            value{
              stringValue
              dateValue
              booleanValue
              numberValue
              arrayValue {
                stringValue
              }
            }
          }
          addresses{fields id type}
          relationships {
            type
            entity {
              name
            }
            values {
              key
              value
            }
          }
        }
        ...on company{
          id
          __typename
          name
          registrationNumber
          natureOfBusiness
          contacts{ id type value }
          addresses{fields id type}
          facts{id type
            value{
              stringValue
              dateValue
              booleanValue
              numberValue
              arrayValue {
                stringValue
              }
            }
          }
        }
        ...on object {
          id
          __typename
          name
          addresses {
            type
            id
            fields
          }
          facts {
            id
            type
            value {
              stringValue
              numberValue
              booleanValue
              dateValue
              arrayValue {
                stringValue
              }
            }
          }
        }
      }
      otherHolders{
        ...on individual{
          id
          __typename
          name
          englishFirstName
          englishLastName
          chineseFirstName
          chineseLastName
          dateOfBirth
          gender
          occupation
          maritalStatus
          employmentStatus
          salutation
          preferredCommunicationChannel
          preferredLanguage
          countryOfResidency
          contacts{ id type value }
          identities{ id type value }
          facts{id type
            value{
              stringValue
              dateValue
              booleanValue
              numberValue
              arrayValue {
                stringValue
              }
            }
          }
          addresses{fields id type}
          relationships {
            type
            entity {
              name
            }
            values {
              key
              value
            }
          }
        }
        ...on company{
          id
          __typename
          name
          registrationNumber
          natureOfBusiness
          contacts{ id type value }
          addresses{fields id type}
          facts{id type
            value{
              stringValue
              dateValue
              booleanValue
              numberValue
              arrayValue {
                stringValue
              }
            }
          }
        }
      }
      offers {
        id
        product{ name productId{ plan type version }}
        premium{
          amount
          originalPrice
          appliedDiscounts{
            code
          }
          currencyCode
        }
      }
      status
      cancellationReason
      startDate
      endDate
      referrer{ name }
      rejectionCodes { code name }
      rejectionRemarks
      paymentInfos{
        id
        method
        name
        amount
        comment
        currencyCode
        frequency
      }
    }
  }
}
`

const checkOffer = `
query checkDiscounts($skip: Int, $limit: Int, $sort: sortInput, $where: policyWhereInput){
  policies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    list {
      offers {
        id
        premium{
          appliedDiscounts{
            code
          }
        }
      }
    }
  }
}
`

const quoteTransactions = `
query policies($where: policyWhereInput $skip: Int $limit: Int $sort: sortInput){
  policies(where:$where skip: $skip limit: $limit sort: $sort){
    list{
      transactions{
        id
        formattedTransaction
        status
        dateTime
      }
    }
  }
}
`

const offers = `
fragment Value on scalarValue {
  booleanValue
  dateValue
  stringValue
  numberValue
}

fragment TreeMapValues on scalarValue {
  ...Value
  arrayValue {
    ...Value
    objectValue {
      key value { ...Value }
    }
  }
  objectValue {
    key value { ...Value }
  }
}

query offers($skip: Int, $limit: Int, $sort: sortInput, $where: policyWhereInput){
  policies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list{
      id
      createdAt
      offers {
        id
        createdAt
        premium{
          amount
          currencyCode
          formattedPrice
          originalPrice
          formattedOriginalPrice
          paymentFrequency
          appliedTaxes{
            code
            name
            ratio
            flat
            formattedFlat
            order
            formattedOriginalPrice
            originalPrice
          }
          appliedDiscounts{
            code
            ratio
            flat
            formattedFlat
            order
            formattedOriginalPrice
            originalPrice
          }
          loadings{
            id
            codeName{
              code
              name
            }
            ratio
            flat
          }
        }
        exclusions{
          id
          codeName{
            code
            name
          }
          remark
        }
        product{
          productId{
            plan
            type
            version
          }
          name
          insurer{ id name logoUrls{ typeA } }
          benefits(typeIds: [], includeOptionals: true) { typeId value }
        }
        benefitOptions{
          benefitTypeId
          key
          name
          formattedValue
          value {
            ...TreeMapValues
          }
        }
      }
    }
  }
}
`

const loadingSettings = `
query loadingSettings($where: productWhereInput){
  products_2(where:$where){
    list{
      loadingSettings{
            codeNames{
                  code
                  name
            }
      }
    }
  }
}
`

const exclusionsSettings = `
query exclusionsSettings($where: productWhereInput){
  products_2(where:$where){
    list{
      exclusionSettings{
        codeNames{
          code
          name
        }
      }
    }
  }
}
`

const createQuote = `
mutation createQuote($policy: initializePolicyInput){
  initializePolicy(policy: $policy){
    status
    errors
    policyStatus{
      id
    }
  }
}`

const addOffer = `
mutation addOfferToQuote($policyId: String! $offerInput: addOfferInput!){
  addOffer(policyId:$policyId offerInput:$offerInput){
    status
    errors
  }
}`

const sendNotification = `
mutation sendNotification($input: sendNotificationInput!) {
  sendNotification(input: $input) {
    errors
    status
  }
}
`

const addLoading = `
mutation addLoading($policyId:String! $input:loadingInput!){
  addLoadingToOffer(policyId:$policyId input:$input){
    status
    errors
  }
}`

const removeLoading = `
mutation removeLoading($policyId:String! $offerId: String $loadingId: String!){
  removeLoadingFromOffer(policyId:$policyId offerId: $offerId loadingId:$loadingId){
    status
    errors
  }
}`

const addExclusion = `
mutation addExclusionToOffer($policyId:String! $input:exclusionInput!){
  addExclusionToOffer(policyId:$policyId input:$input){
    status
    errors
  }
}`

const removeExclusion = `
mutation removeExclusionFromOffer($policyId:String! $offerId: String $exclusionId: String!){
  removeExclusionFromOffer(policyId: $policyId offerId: $offerId exclusionId: $exclusionId ){
    status
    errors
  }
}`

const readRejectionSettings = `
query readRejectionSettings($where: productWhereInput){
  products_2(where: $where){
    list{
      rejectionSettings{
        codeNames{
          code
          name
        }
      }
    }
  }
}
`

const rejectQuote = `
  mutation rejectQuote($policyId:String! $codes:[String] $remarks:String){
    rejectQuote(policyId:$policyId codes:$codes remarks:$remarks){
        errors
        status
    }
  }
`

const validatePolicy = `
query validatePolicy($policyId: String!){
  validatePolicy_2(policyId: $policyId){
    status
    errors
    errors_2{
      code
      message
    }
  }
}`

const issuePolicy = `
mutation issuePolicy($policyId: String! $issuerNumber: String $isManual: Boolean){
  issuePolicy(policyId: $policyId issuerNumber: $issuerNumber isManual: $isManual){
    status
    errors
    policyStatus{
      id
      status
    }
  }
}
`

const convertOffer = `
mutation convertOffer($policyId: String! $offerId: String!){
  convertOffer(policyId: $policyId offerId: $offerId){
    status
    errors
  }
}
`

const removeOffer = `
mutation removeOffer($policyId: String! $offerId: String!){
  removeOffer(policyId: $policyId offerId: $offerId){
    status
    errors
  }
}
`

const initializeTransaction = `
mutation initializeTransaction($input: initializeTransactionInput!){
  initializeTransaction(input:$input){
    value{
      token
      url
      transactionId
    }
    errors
  }
}
`

const quoteLogs = `
query policies($where: policyWhereInput $skip: Int $limit: Int $sort: sortInput){
  policies(where:$where skip: $skip limit: $limit sort: $sort){
    list{
      events{
        timestamp
        by{
          username
        }
        type
      }
    }
  }
}
`

const updateQuote = `
mutation updatePolicy($policyId: String! $updatedPolicy: updatePolicyInput!){
  updatePolicy(policyId: $policyId updatedPolicy: $updatedPolicy){
    status
  }
}
`
const updateOffer = `
mutation updateOffer($policyId: String! $offerId: String! $updateOfferInput: updateOfferInput!) {
  updateOffer(policyId: $policyId offerId: $offerId updateOfferInput: $updateOfferInput) {
    errors
    errors_2 {
      code
      message
    }
    status
  }
}
`

/**
 * Asia queries
 */
const getPrice = `
query getPrice($skip: Int, $limit: Int, $sort: sortInput, $where: productWhereInput $values:[keyValueInput] $discountCodes:[String]){
  products_2(skip: $skip, limit: $limit, sort: $sort, where: $where values:$values){
    totalCount
    list{
      pricing(values:$values discountCodes:$discountCodes){
        formattedPrice
        amount
        originalPrice
        formattedOriginalPrice
        currencyCode
        appliedTaxes{
          code
          name
          ratio
          flat
          formattedFlat
          order
          formattedOriginalPrice
          originalPrice
          newPrice
        }
        appliedDiscounts{
          code
          ratio
          flat
          formattedFlat
          order
          formattedOriginalPrice
          originalPrice
          newPrice
        }
      }
    }
  }
}
`

const individual = `
query individuals($skip: Int, $limit: Int, $sort: sortInput, $where: individualWhereInput){
  individuals(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list {
      id
      __typename
      name
      englishFirstName
      englishLastName
      chineseFirstName
      chineseLastName
      dateOfBirth
      gender
      occupation
      maritalStatus
      employmentStatus
      salutation
      preferredCommunicationChannel
      preferredLanguage
      countryOfResidency
    }
  }
}
`

const company = `
query companies($skip: Int, $limit: Int, $sort: sortInput, $where: companyWhereInput){
  companies(skip: $skip, limit: $limit, sort: $sort, where: $where){
    totalCount
    list {
      id
      __typename
      name
      registrationNumber
      natureOfBusiness
    }
  }
}
`

const addInsured = `
mutation addInsured($policyId: String! $entityId: String!){
      addInsured(policyId: $policyId, entityId: $entityId){
            status
      }
}
`

const removeInsured = `
mutation removeInsured($policyId: String! $entityId: String!){
      removeInsured(policyId: $policyId, entityId: $entityId){
            status
      }
}
`
const addOtherHolder = `
mutation addOtherHolder($policyId: String! $entityId: String!){
      addOtherHolder(policyId: $policyId, entityId: $entityId){
            status
      }
}
`

const removeOtherHolder = `
mutation removeOtherHolder($policyId: String! $entityId: String!){
      removeOtherHolder(policyId: $policyId, entityId: $entityId){
            status
      }
}
`
const addPaymentInfo = `
mutation addPaymentInfo($policyId: String! $input: addPaymentInfoInput!){
  addPaymentInfo(policyId: $policyId, input: $input){
            status
      }
}
`

const updatePaymentInfo = `
mutation updatePaymentInfo($id: String! $paymentId: String! $updateIssuedPaymentInput: paymentInfosToUpdate!){
  updatePaymentInfo(id: $id, paymentId: $paymentId, updateIssuedPaymentInput: $updateIssuedPaymentInput){
            status
      }
}
`

const removePaymentInfo = `
mutation removePaymentInfo($id: String! $paymentId: String!){
  removePaymentInfo(id: $id, paymentId: $paymentId){
            status
      }
}
`

const deleteQuote = `
mutation deletePolicy($id: String!){
  deletePolicy(id: $id){
    status
    errors
  }
}`

const query = {
	quotes,
	quote,
	offers,
	quoteTransactions,
	loadingSettings,
	exclusionsSettings,
	readRejectionSettings,
	getPrice,
	quoteLogs,
	validatePolicy,
	individual,
	company,
	checkOffer
}

const mutation = {
	createQuote,
	addOffer,
	updateOffer,
	addLoading,
	addExclusion,
	removeExclusion,
	removeLoading,
	sendNotification,
	rejectQuote,
	issuePolicy,
	convertOffer,
	removeOffer,
	initializeTransaction,
	updateQuote,
	addInsured,
	removeInsured,
	addOtherHolder,
	removeOtherHolder,
	addPaymentInfo,
	updatePaymentInfo,
	removePaymentInfo,
	deleteQuote
}
export { query, mutation }
